import { PERMISSION_TYPE } from '@/constants'

const { CHAIN_MANAGER, CHAIN_OPERATOR } = PERMISSION_TYPE

export default {
  name: 'places',
  permission: [CHAIN_MANAGER, CHAIN_OPERATOR],
}
